import CourseSettingsService from 'services/course-settings-service';
import LearnerProfileService from 'services/learner-profile-service';
import EnrollmentDataService from 'services/enrollment-data-service';
import ProgressService from 'services/content-service/progress-service';
import { timerService } from 'services/timer-service';
import { CountDownTimerWithEvents } from 'services/timer/countdown-timer';
import { TimerWithEvents } from 'services/timer/timer';

function CourseTimerService(
  courseSettingsService,
  learnerProfileService,
  enrollmentDataService,
  timerService
) {
  if(!courseSettingsService || !learnerProfileService || !enrollmentDataService) {
    throw Error(
      'CourseTimerService: No courseSettings, learnerProfile or enrollmentDataService provided'
    );
  }
  let courseTimerConfig;
  this.initialize = function() {
    this.courseTimers = {};

    try {
      if(courseTimerConfig) {
        return this.courseTimers;
      }
      const courseCountdownTimerStoredData = this.getTimerConfigForProfile('courseCountdownTimer');
      const courseTimerStoredData = this.getTimerConfigForProfile('courseTimer');
      this.courseTimers.courseCountdownTimer = new CountDownTimerWithEvents(
        courseCountdownTimerStoredData
      );
      this.courseTimers.courseCountdownTimer.setTickEventPeriod(10);

      this.courseTimers.courseTimer = new TimerWithEvents(courseTimerStoredData);
      timerService.registerTimers([
        this.courseTimers.courseCountdownTimer,
        this.courseTimers.courseTimer
      ]);
      this.courseTimers.courseTimer.setTickEventPeriod(10);
      this.registerEnrollmentDataEvents();
      return this.courseTimers;
    } catch(err) {
      // eslint-disable-next-line no-console
      console.error(`CourseTimerService: ${err}`);
      return {};
    }
  };
  // Get the configuratin from course-settings
  this.getTimerConfigForProfile = function(timerKey) {
    const profileType = learnerProfileService.get('learner_type');
    let profileLocation = learnerProfileService.get('learner_location_iso_code');
    const enrollmentData = enrollmentDataService.getData('courseLevelTimer');
    courseTimerConfig = courseSettingsService.get('timerConfig').courseLevelTimers;

    // go through current type durations to find a location match. if no match or location is null, set it to default
    if (profileLocation) {
      let thisLocation = 'default';
      for (const duration in courseTimerConfig[profileType].durations) {
        if (profileLocation === duration) {
          thisLocation = profileLocation;
        }
      }
      profileLocation = thisLocation;
    } else {
      profileLocation = 'default';
    }
    if(!courseTimerConfig || !profileType || !profileLocation) {
      throw Error('getTimerConfigForProfile: no timerConfig or learnerType configuration');
    }
    const enrollmentTimerData = enrollmentData ? enrollmentData[timerKey] || {} : {};
    const timerConfigProfile = courseTimerConfig[profileType];
    const timerConfig = timerConfigProfile ? timerConfigProfile.durations[profileLocation] : {};
    return Object.assign({}, timerConfig, enrollmentTimerData);
  };
  // Register callbacks to save the data to enrollment data => local storage
  this.registerEnrollmentDataEvents = () => {
    Object.entries(this.courseTimers).forEach(([key, timer]) => {
      if(timer.eventManager) {
        timer.on('tick', () => {
          this.storeCourseTimer({ key, timer });
        });
        timer.on('completed', () => {
          this.storeCourseTimer({ key, timer });
        });
      }
    });
  };

  this.storeCourseTimer = ({ key, timer }) => {
    try {
      const prevCourseTimerData = enrollmentDataService.getData('courseLevelTimer');
      enrollmentDataService.saveData(
        'courseLevelTimer',
        Object.assign({}, prevCourseTimerData, { [key]: timer })
      );
      if(!EF.options.local && key === 'courseTimer') {
        ProgressService.saveCourseTimeProgress({ intervalSeconds: timer.tickEventPeriod });
      }
    } catch(err) {
      console.error(`Couldn't save data, error: ${err}`);
    }
  };
}

const courseTimerService = new CourseTimerService(
  CourseSettingsService,
  LearnerProfileService,
  EnrollmentDataService,
  timerService
);

export default courseTimerService;
